// FETCH ALL PROPERTIES FROM GENERAL_DC_INWARD DETAILS
export const FETCH_GENERAL_DC_INWARD_DETAILS_REQUEST_DK = 'FETCH_GENERAL_DC_INWARD_DETAILS_REQUEST_DK';
export const FETCH_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK = 'FETCH_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_GENERAL_DC_INWARD_DETAILS_FAILURE_DK = 'FETCH_GENERAL_DC_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM GENERAL_DC_INWARD DETAILS BY ID
export const FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_REQUEST_DK = 'FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_FAILURE_DK = 'FETCH_GENERAL_DC_INWARD_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR GENERAL_DC_INWARD DETAILS
export const CREATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK = 'CREATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK';
export const CREATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK = 'CREATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK = 'CREATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_GENERAL_DC_INWARD_DETAILS_DK = 'CREATE_USER_FORM_GENERAL_DC_INWARD_DETAILS_DK';

// UPDATE PROPERTIES FOR GENERAL_DC_INWARD DETAILS
export const UPDATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK = 'UPDATE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK = 'UPDATE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE GENERAL_DC_INWARD_DETAILS
export const FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR GENERAL_DC_INWARD DETAILS
export const DELETE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK = 'DELETE_GENERAL_DC_INWARD_DETAILS_REQUEST_DK';
export const DELETE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK = 'DELETE_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK = 'DELETE_GENERAL_DC_INWARD_DETAILS_FAILURE_DK';

// USERFORM RESET

export const GENERAL_DC_INWARD_DETAILS_USERFORM_RESET_DK = 'GENERAL_DC_INWARD_DETAILS_USERFORM_RESET_DK';

export const GENERAL_DC_INWARD_DETAILS_DC_DETAILS_DISABLED_DK = 'GENERAL_DC_INWARD_DETAILS_DC_DETAILS_DISABLED_DK';

// FETCH ALL PROPERTIES FROM GENERAL_INWARD DETAILS
export const FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_GENERAL_DC_INWARD_DETAILS_FAILURE_DK';